import React from 'react';
import { Building2 } from 'lucide-react';
import { usePortalBrand } from '../../contexts/PortalBrandContext';

/**
 * The operator's brand picker on catalog pages (Ari, 2026-09-10: "it needs to
 * be clearly there: Select a brand before beginning").
 *
 * Same brains as the navbar switcher — both read and write
 * `PortalBrandContext`, so changing one changes the other. This one is a
 * plain, visible control at the top of the work area rather than a small
 * dropdown in the chrome, because every upload and every edit is attributed
 * to the brand selected here.
 */
const CatalogBrandBar: React.FC = () => {
  const { brands, selectedBrandId, setSelectedBrandId, isLoadingBrands } = usePortalBrand();

  return (
    <div
      data-testid="catalog-admin-brand-bar"
      className="mb-6 flex flex-wrap items-center gap-3 rounded-2xl border border-brand-navy/15 bg-white px-4 py-3 shadow-sm"
    >
      <Building2 className="h-4 w-4 text-brand-navy" aria-hidden="true" />
      <label htmlFor="catalog-brand-select" className="text-sm font-semibold text-gray-900">
        Select a brand before beginning
      </label>
      <select
        id="catalog-brand-select"
        value={selectedBrandId ?? ''}
        disabled={isLoadingBrands || brands.length === 0}
        onChange={(e) => setSelectedBrandId(Number(e.target.value))}
        className="num rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-navy"
      >
        {selectedBrandId == null && <option value="">Choose a brand</option>}
        {brands.map((b) => (
          <option key={b.id} value={b.id}>
            {b.displayName}
          </option>
        ))}
      </select>
      <span className="text-xs text-gray-500">
        Everything you upload or edit is saved to this brand.
      </span>
    </div>
  );
};

export default CatalogBrandBar;
